export default __webpack_public_path__ + "static/media/seller_collection.eb27194c.xlsx";